import React, { useState } from "react";

import LayoutBase from "./layouts/base/base";

// Icons
import searchIcon from "./assets/Images/ico-search.svg";

//Components
import ContentImage from "./components/content-image/content-image";
import Section from "./components/section/section";
import Tiles from "./components/Tiles/tiles";
import Media from "./components/media/media";
import Content from "./components/content/content";
import Map from "./components/map/map";
import SectionForm from "./components/section-form/section-form";
import TableFilters from "./components/table-filters/table-filters";
import FormFilters from "./components/form-filters/form-filters";

//Images
import mediaImage from "./assets/Images/media-image.jpg";

//Data
import heroData from "./data/hero-data";
import tilesData from "./data/tiles-data";
import mapData from "./data/map-data";

function App() {
	const [searchWord, setSearchWord] = useState("");
	const [changed, setChanged] = useState("");

	return (
		<div className="App">
			<LayoutBase>
				<ContentImage heroData={heroData}>
					<p>
						Using Freedom of Information requests, we asked UK
						councils how much they spent on construction in the
						2015/16 and 2020/21 financial years to reveal how
						investment has changed over time.
					</p>

					<p>
						This page includes the key findings, as well as an
						interactive map and table where you can explore the
						level of funding in your area.
					</p>
				</ContentImage>

				<Section>
					<Tiles title="Key Findings:" tilesData={tilesData} />

					<Media media={mediaImage} />

					<Content>
						<p>
							Despite the pandemic naturally affecting investment
							in 2020/21, <strong>almost half (49%)</strong> of
							local authorities spent more on construction than
							they did five years earlier.
						</p>
						<p>
							Welwyn Hatfield Council in the East of England upped
							their spend at the greatest rate, with a staggering
							<strong> 5,482% increase</strong> from £763,863 up
							to £42,639,830.
						</p>
						<p>
							However, on average, local authorities in Wales
							reported the biggest increases, with{" "}
							<strong>26% more </strong>
							funding in 2020/21 than in 2015/16.
						</p>

						<h6>
							To see how much each region invested in construction
							in 2020/21 and how this has changed over time,
							explore our interactive map below.
						</h6>
					</Content>
				</Section>

				<Map
					mapData={mapData}
					title="Amount spent on construction by local councils in the 2015/16 and 2020/21 financial years."
				/>

				<SectionForm title="Data sourced from Freedom of Information requests issued to UK councils in October 2021.">
					<FormFilters
						setSearchWord={setSearchWord}
						setChanged={setChanged}
						icoSearch={searchIcon}
						logo="/Images/ico-bulb.svg"
						label="Search for specific local authorities"
					/>

					<TableFilters searchWord={searchWord} changed={changed} />
				</SectionForm>
			</LayoutBase>
		</div>
	);
}

export default App;
